import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import { Form, Button, Row, Col } from "react-bootstrap";
import { Add, Trash } from "iconsax-react";

import { ROUTE_CART } from "../../../routes";

import grouplImg from "./../../../image/purchase/group-subscription.png";
import {
  calculateUnitOfTimePriceApi,
  cartApi,
  gradeApi,
  unitOfTimeApi,
} from "../../../utility/api/apiList";

import {
  showDangerAlert,
  showInfoAlert,
} from "../../../redux/actions/alert/alertActions";

import { sortByProperty } from "../../../libs/sortByProperty";
import useAxios from "../../../hooks/useAxios";
import useDebounce from "../../../hooks/useDebounce";
import uuidv4 from "../../../libs/getUuIdV4";
import scrollToTop from "../../../libs/scrollToTop";
import { getCookieId } from "../../../libs/getCookieID";
import { subjectOptions, ValueAddedTax } from "../personalPurchase";

import LayoutPurchaseComponent from "../../../components/public/purchase/layoutPurchase";
import ButtonComponent from "../../../components/public/button";
import SecondaryButtonComponent from "../../../components/public/purchase/secondaryButton";
import InputComponent from "../../../components/public/form/input";
import { PriceBoxComponent } from "../../../components/public/purchase/personalPurchase/cards";
import {
  DropdownIndicatorComponent,
  customStyles,
} from "../../../components/public/purchase/select/styledPurchaseSelect";
import { Wrapper, StyledRow } from "./styledGroupPurchase";

export const PurchaseSelect = (props) => {
  const { components, ...setting } = props;

  return (
    <Select
      components={{ DropdownIndicatorComponent, ...components }}
      styles={customStyles}
      isSearchable={false}
      {...setting}
    />
  );
};

const GroupPurchasePageContainer = () => {
  const [gradeList, setGradeList] = useState([]);
  const [productOrderCompanyList, setProductOrderCompanyList] = useState([
    {
      id: "orderedPackage-1",
      grade: 0,
      number: null,
      dateId: 0,
      discount: 0,
      priceWithNoDiscount: 0,
      totalPrice: 0,
    },
  ]);
  const [unitTimeList, setUnitTimeList] = useState([]);
  const [countId, setCountId] = useState(2);
  const [changeInputs, setChangeSetInputs] = useState();

  const history = useHistory();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.userDetail);
  const { register, handleSubmit, control } = useForm({ mode: "onChange" });

  //useAxios
  const { run: getGradeRun } = useAxios({
    url: gradeApi,
    params: {
      page_size: 100,
    },
  });

  const { run: getUnitOfTimeRun } = useAxios({
    url: unitOfTimeApi,
    params: {
      page_size: 100,
    },
  });
  const { run: calculateUnitOfTimeRun } = useAxios({
    url: calculateUnitOfTimePriceApi,
    method: "post",
  });

  const { run: getCartIsLoginRun } = useAxios({
    url: `${cartApi}${userDetail.isLogin ? "" : `?cookieId=${getCookieId()}`}`,
  });

  //post
  const { run: postCartRun } = useAxios({
    url: cartApi,
    method: "post",
  });

  useEffect(() => {
    scrollToTop();
    document.title = "اشتراک گروهی";

    if (userDetail.isLogin) {
      getGradeRun().then((response) => {
        let filteredArray = response.data.results.filter(
          (item) => item.active === true
        );
        setGradeList(filteredArray.sort(sortByProperty("level")));
      });

      getUnitOfTimeRun().then((response) => {
        setUnitTimeList(response.data.results);
        getCartIsLoginRun().then((responseDetailCart) => {
          let array = [];
          let counterID = countId;
          responseDetailCart.data.data.map((item) => {
            const newElemment = {
              id: `orderedPackage-${counterID}`,
              name: item.grade.name,
              unitoftimeName: item.unitoftime.name,
              grade: item.grade.id,
              number: item.count,
              dateId: item.unitoftime.id,
              discount: item.discount,
              priceWithNoDiscount: item.raw_price,
              totalPrice: item.total_price,
            };
            array.push(newElemment);
            counterID = counterID + 1;
          });
          setCountId(counterID);
          setProductOrderCompanyList(array);
        });
      });
    } else {
      dispatch(showInfoAlert("لطفا ابتدا وارد شوید."));
    }
  }, []);

  useDebounce(
    () => {
      handleTotalPriceOfCompanyProduct();
    },
    [changeInputs],
    600
  );
  const handleAddProductOrderCompanyList = () => {
    setCountId(countId + 1);
    const newElemment = {
      id: `orderedPackage-${countId}`,
      grade: 0,
      number: null,
      dateId: 0,
      discount: 0,
      priceWithNoDiscount: 0,
      totalPrice: 0,
    };
    setProductOrderCompanyList(() => [...productOrderCompanyList, newElemment]);
  };
  const handleRemoveProductOrderCompanyList = (e) => {
    const productList = productOrderCompanyList.filter(
      (item) => item.id !== e.target.id
    );
    setProductOrderCompanyList(productList);
  };
  const handleTotalPriceOfCompanyProduct = () => {
    let dataArray = [];
    let data = { data: dataArray };
    let fullPackages = [];

    for (let item of Object.values(productOrderCompanyList)) {
      if (item.grade !== 0 && item.number !== null && item.dateId !== 0) {
        dataArray.push({
          unit_id: item.dateId,
          grade: item.grade,
          count: item.number,
        });
        fullPackages.push(item);
      }
    }

    calculateUnitOfTimeRun(data).then((response) => {
      let result = response.data.result;
      for (let index in Object.keys(result)) {
        let tempererayList = [...productOrderCompanyList];
        fullPackages[index].discount = result[index].discount;
        fullPackages[index].totalPrice = result[index].price;
        fullPackages[index].priceWithNoDiscount = result[index].raw_price;

        const indexOfProduct = productOrderCompanyList.findIndex(
          (item) => item.id === fullPackages[index].id
        );

        tempererayList[indexOfProduct] = fullPackages[index];
        setProductOrderCompanyList(tempererayList);
      }
    });
  };

  const handleChangeInput = (e, inputId, isGradeInput) => {
    if (inputId) {
      setChangeSetInputs(e.value);
      let tempererayList = productOrderCompanyList.find(
        (item) => item.id === inputId
      );
      if (isGradeInput) {
        tempererayList.grade = e.value;
      } else {
        tempererayList.dateId = e.value;
      }
    } else {
      setChangeSetInputs(e.target.value);
      let tempererayList = productOrderCompanyList.find(
        (item) => item.id === e.target.name
      );
      tempererayList.number = e.target.value;
    }
  };

  const handleSubmitPurchase = () => {
    let cookieIdAxios = getCookieId();
    if (userDetail.isLogin) {
    } else if (cookieIdAxios === "") {
      const unique = uuidv4();
      document.cookie = `id=${unique}`;
    }

    let arraySubmit = [];
    for (let index = 0; index < productOrderCompanyList.length; index++) {
      arraySubmit.push({
        grade: productOrderCompanyList[index].grade,
        count: productOrderCompanyList[index].number,
        unitoftime: productOrderCompanyList[index].dateId,
        salespackage: null,
      });
    }

    if (arraySubmit.length === 0) {
      dispatch(showDangerAlert("سبد خرید شما خالی است!"));
    } else {
      cookieIdAxios = getCookieId();
      let data = {
        data: arraySubmit,
        cookieId: userDetail.isLogin ? null : cookieIdAxios,
      };
      postCartRun({ ...data })
        .then(() => {
          history.push({
            pathname: ROUTE_CART,
          });
        })
        .catch((error) => {
          if (error.response.data.details) {
            dispatch(showDangerAlert(error.response.data.details));
          } else {
            dispatch(
              showDangerAlert("لطفا از درستی اطلاعات وارد شده اطمینان حاصل کنید.")
            );
          }
        });
    }
  };

  return (
    <LayoutPurchaseComponent cardTitle="اشتراک گروهی" $height="auto">
      <Wrapper className="mx-auto d-flex justify-content-center align-items-center">
        <img src={grouplImg} alt="اشتراک گروهی" width="280" />
        <Form onSubmit={handleSubmit(handleSubmitPurchase)} className="w-100">
          {productOrderCompanyList.map((item, index) => (
            <StyledRow
              id={item.id}
              key={item.id}
              className="pt-5 pt-md-1 pb-2 pb-md-1 mb-3"
            >
              <Col xs={12} md={3} className="my-auto mt-3 mt-md-0">
                <Form.Label>مقطع تحصیلی</Form.Label>
                <Controller
                  control={control}
                  name={`grade-select-${index}`}
                  rules={{ required: !item.name }}
                  render={({ field }) => {
                    const { onChange } = field;
                    return (
                      <PurchaseSelect
                        defaultValue={
                          item.name && {
                            label: item.name,
                            value: item.grade,
                          }
                        }
                        onChange={(val) => {
                          onChange(val);
                          handleChangeInput(val, item.id, true);
                        }}
                        options={subjectOptions(gradeList)}
                        placeholder="انتخاب کنید."
                        isDisabled={!userDetail.isLogin}
                      />
                    );
                  }}
                />
              </Col>
              <Col xs={12} md={2} className="my-auto mt-3 mt-md-0">
                <InputComponent
                  title="تعداد"
                  defaultValue={item.number && item.number}
                  type="number"
                  placeholder="0"
                  min="1"
                  register={register(item.id, {
                    required: !item.number,
                    valueAsNumber: true,
                    validate: (value) => value > 0,
                    onChange: (e) => handleChangeInput(e),
                  })}
                  containerClass="number-input"
                  disabled={!userDetail.isLogin}
                />
              </Col>
              <Col xs={12} md={3} className="my-auto mt-3 mt-md-0">
                <Form.Label>بازه زمانی</Form.Label>
                <Controller
                  control={control}
                  name={`unit-of-time-select-${index}`}
                  rules={{ required: !item.unitoftimeName }}
                  render={({ field }) => {
                    const { onChange } = field;
                    return (
                      <PurchaseSelect
                        defaultValue={
                          item.unitoftimeName && {
                            label: item.unitoftimeName,
                            value: item.unitoftime,
                          }
                        }
                        onChange={(val) => {
                          onChange(val);
                          handleChangeInput(val, item.id);
                        }}
                        options={subjectOptions(unitTimeList)}
                        placeholder="انتخاب کنید."
                        isDisabled={!userDetail.isLogin}
                      />
                    );
                  }}
                />
              </Col>
              <Col
                md={4}
                xs={12}
                className="d-flex justify-content-center align-items-end"
              >
                <Button
                  id={item.id}
                  onClick={handleRemoveProductOrderCompanyList}
                  className="trash-button"
                >
                  <Trash
                    size="32"
                    color="var(--blue-color-dark)"
                    className="col-12"
                    onClick={(e) => e.stopPropagation()}
                  />
                </Button>
                <PriceBoxComponent
                  haveDiscount={item?.discount}
                  totalprice={item?.totalPrice}
                  priceBeforeDiscount={item?.priceWithNoDiscount}
                  priceAfterDiscount={item?.totalPrice}
                />
              </Col>
            </StyledRow>
          ))}
          <Row className="mb-3">
            <ButtonComponent
              className={`col-12 ${!userDetail.isLogin && "disabled"}`}
              onClick={handleAddProductOrderCompanyList}
              disabled={!userDetail.isLogin}
            >
              <>
                افزودن
                <Add size="19" color="var(--white-color)" />
              </>
            </ButtonComponent>
          </Row>
          {productOrderCompanyList.length < 2 && <ValueAddedTax />}
          <Row className="mt-5 mt-md-3 mb-5 mb-md-3 p-0" dir="ltr">
            <SecondaryButtonComponent
              titleButton="ادامه و تایید خرید"
              buttonType="submit"
              wrapperButtonclassName="mx-auto mx-md-0 col-md-3 col-12 p-0"
              isDisabledButton={!userDetail.isLogin}
            />
          </Row>
          {productOrderCompanyList.length < 2 && (
            <Row>
              <p className="caption mx-auto col-12 col-md-7 text-center">
                برای دانش‌آموزان خود به صورت گروهی خرید کنید و از تخفیف ویژه برخوردار
                شوید. برای اطلاعات بیشتر با شماره 77245204 تماس حاصل فرمائید.
              </p>
            </Row>
          )}
        </Form>
      </Wrapper>
    </LayoutPurchaseComponent>
  );
};

export default GroupPurchasePageContainer;
